import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { KalTableHeader } from 'src/app/_shared/modules/kal-table/classes/kal-table-header';
import { AdvancedRuleService, ParameterModel } from 'src/app/_shared/services/advanced-rule/advanced-rule.service';

@Component({
    selector: 'app-shared-advanced-rule-criterion-parameters-detail',
    templateUrl: './shared-advanced-rule-criterion-parameters-detail.component.html',
    styleUrls: ['./shared-advanced-rule-criterion-parameters-detail.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAdvancedRuleCriterionParametersDetailComponent {

    @Input() parameters: ParameterModel[] = [];

    columns: KalTableHeader<ParameterModel>[] = [
        {code: 'IdCritere', label: 'Libellé paramètre'},
        {code: 'IdOperateur', label: 'Opérateur'},
        {code: 'Valeur', label: 'Valeur'},
    ];

    operatorsList = this.activityService.operatorList;
    criteriaList = this.activityService.criteriaList;

    constructor(private readonly activityService: AdvancedRuleService) {
    }
}
